import {
  ActionsPendency,
  PendencyAfterOperatorRequestListEnum,
  PendencyDocInitialListEnum
} from 'common/enum/actions-pendency'
import * as yup from 'yup'
import 'main/config/yup'
import { isValidBrazilianPhone } from 'common/utils/phone'

export const validationSchema = yup.object().shape({
  notify_doctor: yup.boolean(),
  notify_secretary: yup.boolean(),
  notify_patient: yup.boolean(),

  email_doctor: yup.string().email().when('notify_doctor', {
    is: true,
    then: yup.string().email().required()
  }),

  email_secretary: yup.string().email().when('notify_doctor', {
    is: true,
    then: yup.string().email()
  }),

  email_patient: yup.string().email().when('notify_patient', {
    is: true,
    then: yup.string().email().required()
  }),

  phone_doctor: yup
    .string()
    .test(
      'doctor-phone-valid',
      'Formato do telefone está inválido',
      (value) => !value || isValidBrazilianPhone(value)
    )
    .test(
      'doctor-or-secretary-phone',
      'Informe pelo menos um telefone válido do médico ou secretária',
      function (value) {
        const { notify_doctor, phone_secretary } = this.parent as any
        if (!notify_doctor) return true
        const dValid = isValidBrazilianPhone(value)
        const sValid = isValidBrazilianPhone(phone_secretary)
        return dValid || sValid
      }
    )
    .nullable()
    .optional(),

  phone_secretary: yup
    .string()
    .test(
      'secretary-phone-valid',
      'Formato do telefone está inválido',
      (value) => !value || isValidBrazilianPhone(value)
    )
    .test(
      'secretary-or-doctor-phone',
      'Informe pelo menos um telefone válido do médico ou secretária',
      function (value) {
        const { notify_doctor, phone_doctor } = this.parent as any
        if (!notify_doctor) return true
        const sValid = isValidBrazilianPhone(value)
        const dValid = isValidBrazilianPhone(phone_doctor)
        return sValid || dValid
      }
    )
    .nullable()
    .optional(),

  phone_patient: yup.string().when('notify_patient', {
    is: true,
    then: yup
      .string()
      .test('patient-phone-valid', 'Telefone inválido do paciente', (v) =>
        isValidBrazilianPhone(v)
      )
      .required('Telefone do paciente é obrigatório'),
    otherwise: yup.string().optional()
  }),

  selected_options: yup.array().when('action', {
    is: (action: ActionsPendency) =>
      action === ActionsPendency.CRMO_CREATED_PENDENCY_AUTH_DIVERGENCE ||
      action === ActionsPendency.CRMO_CREATED_PENDENCY_PERSONALIZED,
    then: yup.array().of(yup.string()),
    otherwise: yup
      .array()
      .of(yup.string())
      .min(1, 'Selecione pelo menos uma opção')
  }),

  OPTION_OTHERS_TEXT: yup.string().when('selected_options', {
    is: (selected_options: string[]) =>
      selected_options.includes(PendencyDocInitialListEnum.OTHERS),
    then: yup
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(150, 'Máximo de 150 caracteres')
      .required()
  }),

  OPTION_SUPPLEMENTARY_MEDICAL_REPORT_TEXT: yup
    .string()
    .when('selected_options', {
      is: (selected_options: string[]) =>
        selected_options.includes(
          PendencyAfterOperatorRequestListEnum.SUPPLEMENTARY_MEDICAL_REPORT
        ),
      then: yup
        .string()
        .min(2, 'Mínimo 2 caracteres')
        .max(150, 'Máximo de 150 caracteres')
        .required()
    }),

  OPTION_EXAM_REPORTS_PHOTOS_TEXT: yup.string().when('selected_options', {
    is: (selected_options: string[]) =>
      selected_options.includes(
        PendencyAfterOperatorRequestListEnum.EXAM_REPORTS_PHOTOS
      ),
    then: yup
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(150, 'Máximo de 150 caracteres')
      .required()
  }),

  OPTION_SUPPLIERS_TEXT: yup.string().when('selected_options', {
    is: (selected_options: string[]) =>
      selected_options.includes(PendencyAfterOperatorRequestListEnum.SUPPLIERS),
    then: yup
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(150, 'Máximo de 150 caracteres')
      .required()
  }),

  OPTION_PERSONALIZED_TEXT: yup.string().when('action', {
    is: (action: ActionsPendency) =>
      action === ActionsPendency.CRMO_CREATED_PENDENCY_PERSONALIZED,
    then: yup
      .string()
      .min(2, 'Mínimo 2 caracteres')
      .max(3900, 'Máximo de 4000 caracteres')
      .required()
  }),

  general_observations: yup.string().max(4000)
})
